// Scrolls the first visible field-level validation error into view. Error markers
// (`data-field-error`) render a tick after the form is told to reveal its errors, so
// we retry briefly until one shows up before giving up.
export function scrollToFirstFieldError({ attempts = 8, intervalMs = 50 } = {}) {
  let tries = 0;

  const tick = () => {
    const el = document.querySelector('[data-field-error]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    tries += 1;
    if (tries < attempts) setTimeout(tick, intervalMs);
  };

  tick();
}
